import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, getApiClient } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { getReportingTrialStatusQueryKey } from './useReportingTrialStatusQuery';

export const useMarkOrgEligibleForReportingMonetizationMutation = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: () =>
      getApiClient().costReport.markOrgEligibleForReportingMonetization({
        body: {},
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getReportingTrialStatusQueryKey(currentOrganization?.id),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
